import React, { useEffect, useContext } from 'react';

import SiteSeeContext from './SiteSeeContext';

const SiteSeeResidencesGuide = () => {
  const { siteSeeName, actionWord, siteSeeGuideMode } = useContext( SiteSeeContext );
  const isCoached = siteSeeGuideMode === 'tour';
  const mapShell = document?.querySelector( '.mapShell' ) ? document.querySelector( '.mapShell' ) : null;
  const mapShellClassList = mapShell ? mapShell.classList : null;

  useEffect( () => {
    if ( !mapShell ) return;
    if ( isCoached ) {
      mapShellClassList?.add( 'mapShell--dimForResidences' );
    } else {
      mapShellClassList?.remove( 'mapShell--dimForResidences' );
    }
    return () => {
      mapShellClassList?.remove( 'mapShell--dimForResidences' );
    };
  }, [ isCoached, mapShellClassList ] );

  return (
    <>
      { actionWord }
      {' '}
      any
      {' '}
      {siteSeeName}
      {' '}
      labeled residence to reveal floor plan images, dimensions
      , and more for a particular community residence.
    </>
  );
};

export default SiteSeeResidencesGuide;
